import { NavigateNext } from "@mui/icons-material"
import { Box, Breadcrumbs, Link, Typography } from "@mui/material"
import { useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { DELIVERY_OPTIONS } from "src/app/constants"
import AppNavLink from "./AppNavLink"
import { useLocation } from "react-router-dom"
import { hasBeerOrSeltzerItemsSelector } from "src/features/checkout/checkoutSlice"

const CartLink = () => (
  <Link
    color="#ab211c"
    component={AppNavLink}
    fontSize={12}
    to={`${window.location.origin}/cart`}
    underline="none"
  >
    Cart
  </Link>
)

const OptionsLink = () => (
  <Link
    color="inherit"
    component={AppNavLink}
    fontSize={12}
    to="options"
    underline="none"
  >
    Options
  </Link>
)

const InformationLink = () => (
  <Link
    color="inherit"
    component={AppNavLink}
    fontSize={12}
    to="information"
    underline="none"
  >
    Information
  </Link>
)

const DeliveryLink = () => {
  const { buyerIdentity } = useSelector((state) => state.checkout.cart)

  return (
    <Link
      color="inherit"
      component={buyerIdentity?.deliveryAddressPreferences?.[0] ? AppNavLink : Typography}
      fontSize={12}
      to="delivery"
      underline="none"
    >
      Delivery
    </Link>
  )
}

const ShippingLink = () => {
  const { buyerIdentity } = useSelector((state) => state.checkout.cart)

  return (
    <Link
      color="inherit"
      component={buyerIdentity?.deliveryAddressPreferences?.[0] ? AppNavLink : Typography}
      fontSize={12}
      to="shipping"
      underline="none"
    >
      Shipping
    </Link>
  )
}

const ScheduleLink = () => {
  const { buyerIdentity, deliveryGroups } = useSelector(
    (state) => state.checkout.cart,
  )
  const deliveryOption = useSelector(
    (state) => state.checkout.options.deliveryOption,
  )
  const [isEnabled, setIsEnabled] = useState(false)

  useEffect(() => {
    if (
      ([
        DELIVERY_OPTIONS.LOCAL_DELIVERY,
        DELIVERY_OPTIONS.NEIGHBOR_ISLAND_SHIPPING,
        DELIVERY_OPTIONS.US_MAINLAND_SHIPPING,
      ].includes(deliveryOption) &&
        buyerIdentity?.deliveryAddressPreferences?.[0] &&
        deliveryGroups?.edges[0]?.node.selectedDeliveryOption?.handle) ||
      deliveryOption === DELIVERY_OPTIONS.LOCAL_PICKUP
    ) {
      setIsEnabled(true)
    }
  }, [deliveryOption, buyerIdentity, deliveryGroups])

  return (
    <Link
      color="inherit"
      component={isEnabled ? AppNavLink : Typography}
      fontSize={12}
      to="schedule"
      underline="none"
    >
      Schedule
    </Link>
  )
}

const PaymentLink = () => {
  const location = useLocation()

  return (
    <Typography
      fontSize={12}
      fontWeight={location.pathname === "/payment" ? "bold" : 400}
    >
      Payment
    </Typography>
  )
}

const initialBreadCrumbs = [
  <CartLink key="cart" />,
  <OptionsLink key="options" />,
]

export default () => {
  const location = useLocation()
  const deliveryOption = useSelector(
    (state) => state.checkout.options.deliveryOption,
  )
  const hasBeerOrSeltzerItems = useSelector(hasBeerOrSeltzerItemsSelector)

  useEffect(() => {
    if (location.pathname) {
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
  }, [location])

  const breadcrumbs = useMemo(() => {
    if (!deliveryOption) {
      return initialBreadCrumbs
    }

    if (
      deliveryOption === DELIVERY_OPTIONS.LOCAL_DELIVERY ||
      ([
        DELIVERY_OPTIONS.NEIGHBOR_ISLAND_SHIPPING,
        DELIVERY_OPTIONS.US_MAINLAND_SHIPPING,
      ].includes(deliveryOption) && !hasBeerOrSeltzerItems)
    ) {
      return [
        ...initialBreadCrumbs,
        <InformationLink key="information" />,
        deliveryOption === DELIVERY_OPTIONS.LOCAL_DELIVERY ? (
          <DeliveryLink key="delivery" />
        ) : (
          <ShippingLink key="shipping" />
        ),
        <ScheduleLink key="schedule" />,
        <PaymentLink key="payment" />,
      ]
    }

    if (deliveryOption === DELIVERY_OPTIONS.LOCAL_PICKUP) {
      return [
        ...initialBreadCrumbs,
        <ScheduleLink key="schedule" />,
        <InformationLink key="information" />,
        <PaymentLink key="payment" />,
      ]
    }

    if ([DELIVERY_OPTIONS.US_MAINLAND_SHIPPING, DELIVERY_OPTIONS.NEIGHBOR_ISLAND_SHIPPING].includes(deliveryOption)) {
      return [...initialBreadCrumbs, <InformationLink key="information" />]
    }
  }, [deliveryOption])

  return (
    <Box paddingY={1}>
      <Breadcrumbs
        // maxItems={4}
        // itemsBeforeCollapse={3}
        itemsBeforeCollapse={3}
        itemsAfterCollapse={0}
        maxItems={screen.width < 400 ? 3 : 8}
        separator={<NavigateNext fontSize="small" />}
        aria-label="breadcrumb"
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Box>
  )
}
